import _ from "lodash";
import { CollectionAdapter } from "../../main/adapters/CollectionAdapter/CollectionAdapter";
import { HttpAdapter } from "../../main/adapters/HttpAdapter";

const ScenarioCollection = new Mongo.Collection("Scenarios", {
    connection: null
});

/**
 * @class
 * Responsavel por cuidar dos dados dos Scenarios usados no dashboard
 */
export class Scenario extends CollectionAdapter {
    HttpAdapter = new HttpAdapter();
    baseUrlScenario = `${publicSettings.aws.baseUrls.dataTimeseries}/scenario`;

    constructor({ Point } = {}) {
        super(ScenarioCollection);
        this.Point = Point;
        this.points = [];
    }

    async remove(companyId, scenarioId) {
        let response = null;
        try {
            await this.HttpAdapter.call(
                `${this.baseUrlScenario}/remove-by-companyid-id`,
                {
                    companyId,
                    _id: scenarioId
                }
            );
            this.delete(scenarioId);
            return true;
        } catch (error) {
            console.error("Erro in Scenario.remove");
        }
        return response;
    }

    async _getByCompanyId(companyId) {
        try {
            const { response } = await this.HttpAdapter.call(
                `${this.baseUrlScenario}/get-by-companyid`,
                {
                    companyId
                }
            );
            return response.length ? response : [];
        } catch (error) {
            return [];
        }
    }

    async populateAll({ companyId }) {
        const scenarios = await this._getByCompanyId(companyId);
        this.deleteMany({ companyId: { $eq: companyId } });
        const _notExistScnearioOriginal = (_id) =>
            !this.findOneCollection(
                {
                    _id: { $eq: _id },
                    companyId: { $eq: companyId }
                },
                { fields: { _id: 1 } }
            );
        if (_notExistScnearioOriginal("ORIGINAL")) {
            scenarios.push({
                _id: "ORIGINAL",
                name: "Original",
                companyId: companyId,
                first: 2
            });

            this.delete("ORIGINAL");
        }
        const _notExistScnearioBase = (_id) =>
            !this.findOneCollection(
                { _id: { $eq: _id } },
                { fields: { _id: 1 } }
            );
        if (_notExistScnearioBase("BASE_ZERO")) {
            scenarios.push({
                _id: "BASE_ZERO",
                name: "Base Zero",
                public: true,
                first: 1
            });
        }
        this.createMany(scenarios);
        return true;
    }

    async populate({ companyId, hasScenario }) {
        let scenarios = [];
        if (_.get(hasScenario, "length")) {
            scenarios = await this._getByCompanyId(companyId);
        }
        this.deleteMany({ companyId: { $eq: companyId } });
        const _notExistScnearioOriginal = (_id) =>
            !this.findOneCollection(
                {
                    _id: { $eq: _id },
                    companyId: { $eq: companyId }
                },
                { fields: { _id: 1 } }
            );
        if (_notExistScnearioOriginal("ORIGINAL")) {
            scenarios.push({
                _id: "ORIGINAL",
                name: "Original",
                companyId: companyId,
                first: 2
            });

            this.delete("ORIGINAL");
        }
        const _notExistScnearioBase = (_id) =>
            !this.findOneCollection(
                { _id: { $eq: _id } },
                { fields: { _id: 1 } }
            );
        if (_notExistScnearioBase("BASE_ZERO")) {
            scenarios.push({
                _id: "BASE_ZERO",
                name: "Base Zero",
                public: true,
                first: 1
            });
        }
        this.createMany(scenarios);
        return true;
    }

    /**
     * @public
     * @param {String} id
     */
    getById(_id, scenarioType) {
        if (_id === "PROGRESSAO_LINEAR") {
            return {
                _id: "PROGRESSAO_LINEAR",
                name: "Projeção Linear"
            };
        }

        if (_id === "ORIGINAL") {
            return {
                _id: "ORIGINAL",
                name: ["projection"].includes(scenarioType)
                    ? "Projeção Linear"
                    : "Original"
            };
        }

        return this.findOneCollection({
            _id: { $eq: _id }
        });
    }

    getByCompany(companyId) {
        let { list } = this.findCollection({
            companyId: { $eq: companyId }
        });
        return list;
    }

    getByCompanyIdAndSource(companyId, source, scenarioType, options = {}) {
        const { list } = this.findCollection(
            {
                companyId: { $eq: companyId }
            },
            { sort: { first: -1, name: 1 } }
        );

        let scenarios = list.filter((scenario) => {
            return !scenario.source || scenario.source === source;
        });

        if (scenarioType) {
            if (scenarioType === "standard") {
                scenarios = scenarios.filter((scenario) => {
                    return scenario.type === scenarioType || !scenario.type;
                });
            } else {
                scenarios = scenarios.filter((scenario) => {
                    return (
                        scenario.type === scenarioType ||
                        scenario._id === "ORIGINAL" ||
                        scenario.type === "standard"
                    );
                });
            }

            if (["projection"].includes(scenarioType)) {
                const scenarioIndex = scenarios.findIndex(
                    (sc) => sc._id === "ORIGINAL"
                );
                scenarios[scenarioIndex].name = "Projeção Linear";
            }

            if (options.removeOriginal)
                scenarios = scenarios.filter(
                    (scenario) => scenario._id !== "ORIGINAL"
                );
        }

        if (options.addProjection) {
            scenarios.unshift({
                _id: "PROGRESSAO_LINEAR",
                name: "Projeção Linear",
                type: "projection"
            });
        }

        if (options.filterAnalysisPlus)
            scenarios = scenarios.filter(
                (s) => !["budget", "projection"].includes(s.type)
            );

        if (options.addBaseZero) {
            scenarios.unshift({
                _id: "BASE_ZERO",
                name: "Base Zero",
                public: true,
                first: 1
            });
        }

        return scenarios;
    }

    /**
     * @public
     * Seta points de cenarios
     * @param {Object} scenario: { object }, points : array
     *
     * @return {Boolean}
     */
    async setPoints({
        accountingId,
        points,
        scenario,
        source,
        _id,
        companyId
    } = {}) {
        const _toBeSaved = (points, scenarioId) => {
            const isValidParam = typeof scenarioId == "string";
            const _id = isValidParam ? scenarioId : _.get(scenario, "_id");

            return points.filter((s) => {
                if (isValidParam && source == "custom") {
                    return s.scenarioId == _id || s.scenarioId == "m";
                }
                return s.scenarioId == _id;
            });
        };

        const pointsToSave = _toBeSaved(points, _id).map((point) => ({
            time: point.time,
            measures: { v: point.value },
            serieId: point.serieId
        }));

        if (!pointsToSave.length) return null;

        await this.Point.saveMany({
            accountingId,
            companyId,
            source,
            points: pointsToSave,
            scenarioId: _id
        }); // Salvar points no backend
    }

    /**
     * @public
     * Retorna companyId e seriesId dos points.
     */
    getCompanyIdAndSeriesIdByPoints() {
        let companyId;
        let seriesId = [];

        this.points.forEach((_id) => {
            if (!_id) return _id;

            const data = _id.split(":");
            if (data[0] && !companyId) companyId = data[0];
            if (!_.includes(seriesId, data[1])) seriesId.push(data[1]);
        });

        return {
            companyId,
            seriesId
        };
    }

    async updateNameById({ _id, name }) {
        if (!_id || !name) return false;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlScenario}/update-name-by-id`,
                {
                    _id,
                    name
                }
            );
            this.modify({ _id: { $eq: _id } }, { $set: { name } });
            return response;
        } catch (error) {
            return error;
        }
    }
}
